import React, { useEffect, useState, createContext, useContext } from 'react';
import { Event, EventType } from '../types';
const EVENTS: Event[] = [{
  id: 'muscle',
  name: 'Dubai Muscle Show',
  description: "The Middle East's Leading Health, Fitness & Wellness Event",
  dates: '30 Oct - 01 Nov 2026',
  location: 'Dubai Exhibition Center, Dubai',
  colors: {
    primary: '#000000',
    secondary: '#000000',
    accent: '#000000'
  },
  type: 'B2C'
}, {
  id: 'active',
  name: 'Dubai Active Show',
  description: "The Middle East's Leading Health, Fitness & Wellness Event",
  dates: '30 Oct - 01 Nov 2026',
  location: 'Dubai Exhibition Center, Dubai',
  colors: {
    primary: '#c8e1d9',
    secondary: '#17313a',
    accent: '#000000'
  },
  type: 'B2C'
}, {
  id: 'industry',
  name: 'Dubai Active Industry',
  description: "The Middle East's Leading International Fitness & Wellness Tradeshow",
  dates: '30 Oct - 01 Nov 2026',
  location: 'Dubai Exhibition Center, Dubai',
  colors: {
    primary: '#17313a',
    secondary: '#061419',
    accent: '#2ef2ff'
  },
  type: 'B2B'
}];
interface EventContextType {
  currentEvent: Event;
  allEvents: Event[];
  switchEvent: (eventId: EventType) => void;
  isOnline: boolean;
  lastSyncTime: Date | null;
}
const EventContext = createContext<EventContextType | undefined>(undefined);
export function EventProvider({
  children
}: {
  children: ReactNode;
}) {
  const [currentEventId, setCurrentEventId] = useState<EventType>(() => {
    const saved = localStorage.getItem('showpilot_default_event');
    return saved as EventType || 'muscle';
  });
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastSyncTime, setLastSyncTime] = useState<Date | null>(new Date());
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setLastSyncTime(new Date());
    };
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const switchEvent = (eventId: EventType) => {
    setCurrentEventId(eventId);
    localStorage.setItem('showpilot_default_event', eventId);
  };
  const currentEvent = EVENTS.find(e => e.id === currentEventId) || EVENTS[0];
  return <EventContext.Provider value={{
    currentEvent,
    allEvents: EVENTS,
    switchEvent,
    isOnline,
    lastSyncTime
  }} data-id="element-4267">
      {children}
    </EventContext.Provider>;
}
export function useEvent() {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEvent must be used within EventProvider');
  }
  return context;
}